module.exports = __webpack_public_path__ + "static/18.3_Reformation_of_Christianity-2cd409dd8b7d469204e1190f7ccc89a3.pdf";